<template>
  <div class="services">
    <Button class="top-create--btn" type="primary" @click="showCreateModal('create')">{{
      $t('services.registerService')
    }}</Button>
    <Table :loading="loading" :columns="recordsCol" :data="records"></Table>
    <Modal
      v-model="createModalVisible"
      class-name="services-modal--create"
      :title="$t('services.registerService')"
      :width="600"
      :mask-closable="false"
      @on-ok="save"
    >
      <Form v-if="createModalVisible" ref="Record" :model="record" :rules="rules">
        <Row>
          <i-col span="24">
            <FormItem :label="$t('common.name')" prop="name">
              <i-input v-model="record.name" size="large"></i-input>
            </FormItem>
          </i-col>
          <i-col span="24">
            <FormItem :label="$t('plugins.file')" prop="file">
              <a href="javascript:void(0);" class="upload-file--link" @click="showUploadFileModal">
                {{ $t('upload.uploadFile') }}
              </a>
              <FileListAutoCompeleteSeletor
                ref="fileListSelectRef"
                v-model="record.file"
                :prefix="'file://'"
                placeholder="http://127.0.0.1:63767/services/sample.zip"
              ></FileListAutoCompeleteSeletor>
            </FormItem>
          </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" @click="createModalVisible = false">{{ $t('common.cancel') }}</Button>
        <Button type="primary" :loading="btnLoading" @click="save">{{ $t('common.submit') }}</Button>
      </div>
    </Modal>
    <Modal
      v-model="viewModalVisible"
      class-name="services-modal--view view-form"
      :title="$t('services.serviceDetail')"
      :width="700"
      :mask-closable="false"
    >
      <template v-if="viewForm">
        <Divider>Interfaces</Divider>
        <div v-for="item in Object.keys(viewForm.interfaces)" :key="item" class="view-item">
          <label class="view-item--label">{{ item }}:</label>
          <div>
            <Table :columns="interfaceCol" :data="viewForm.interfaces[item]"></Table>
          </div>
        </div>
        <Divider>About</Divider>
        <div class="view-item">
          <label class="view-item--label">Name:</label>
          <span>{{ viewForm.about.author.name }}</span>
        </div>
        <div class="view-item">
          <label class="view-item--label">Description:</label>
          <span>{{ i18nLabel(viewForm.about.description) }}</span>
        </div>
        <div class="view-item">
          <label class="view-item--label">Company:</label>
          <span>{{ viewForm.about.author.company }}</span>
        </div>
        <div class="view-item">
          <label class="view-item--label">Email: </label>
          <span>{{ viewForm.about.author.email }}</span>
        </div>
        <div class="view-item">
          <label class="view-item--label">Website:</label>
          <a rel="noopener" :href="viewForm.about.author.website" target="_blank">{{
            viewForm.about.author.website
          }}</a>
        </div>
        <div class="view-item">
          <label class="view-item--label">Help URL:</label>
          <a rel="noopener" :href="i18nLabel(viewForm.about.helpUrl)" target="_blank">
            {{ $t('common.documentation') }}
          </a>
        </div>
      </template>
      <div slot="footer">
        <Button type="text" @click="viewModalVisible = false">{{ $t('common.cancel') }}</Button>
      </div>
    </Modal>
    <!-- Upload File -->
    <UploadFileModal
      :modalVisible.sync="uploadFileModalVisible"
      :isSupportCustom="true"
      :fileAccepts="'.zip'"
      @reload="getFileList"
    />
  </div>
</template>

<script lang="jsx">
import { loadServices, registerService, deleteService, loadService, updateService } from '@/api/services'
import nodeID from '@/mixins/nodeID'
import currentLang from '@/mixins/currentLang'
import FileListAutoCompeleteSeletor from '@/views/configuration/uploads/components/FileListAutoSelector.vue'
import UploadFileModal from '@/views/configuration/uploads/UploadFileModal.vue'

export default {
  name: 'Services',

  mixins: [nodeID, currentLang],

  components: { FileListAutoCompeleteSeletor, UploadFileModal },

  data() {
    return {
      loading: false,
      createModalVisible: false,
      viewModalVisible: false,
      btnLoading: false,
      viewLoading: false,
      oper: '',
      record: {},
      viewForm: null,
      rules: {
        name: [{ required: true, message: this.$t('plugins.nameRequired') }],
        file: [{ required: true, message: this.$t('plugins.fileRequired') }],
      },
      uploadFileModalVisible: false,
      records: [],
      recordsCol: [
        {
          title: this.$t('common.name'),
          key: 'name',
          render: (h, params) => {
            return (
              <div>
                <a
                  href="javascript:;"
                  onClick={() => {
                    this.showDetail(params.row)
                  }}
                >
                  {params.row.name}
                </a>
              </div>
            )
          },
        },
        {
          title: this.$t('common.operations'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const editBtn = (
              <a
                href="javascript:;"
                style="margin-right: 10px;"
                vOn:click={() => {
                  this.editService(params.row)
                }}
              >
                <Icon type="ios-create"></Icon>
              </a>
            )
            const deleteBtn = (
              <a href="javascript:;">
                <Poptip
                  confirm={true}
                  transfer={true}
                  width={200}
                  title={this.$t('common.confirmDelete')}
                  placement="top"
                  type="error"
                  vOn:on-ok={() => {
                    this.remove(params.row)
                  }}
                  vOn:on-cancel={() => {}}
                >
                  <Icon type="md-trash"></Icon>
                </Poptip>
              </a>
            )
            return (
              <div>
                {editBtn}
                {deleteBtn}
              </div>
            )
          },
        },
      ],
      interfaceCol: [
        {
          title: 'Key',
          key: 'key',
        },
        {
          title: 'Value',
          key: 'value',
        },
      ],
    }
  },

  watch: {
    createModalVisible(val) {
      if (!val) {
        this.$refs.Record.resetFields()
        this.record = {}
      }
    },
    viewModalVisible(val) {
      if (!val) {
        this.viewForm = null
      }
    },
  },

  created() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.loading = true
      this.records = []
      loadServices(this.nodeID)
        .then((res) => {
          this.records = res.data.map((item) => ({
            name: item,
          }))
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    showDetail({ name }) {
      this.viewModalVisible = true
      this.viewLoading = true
      loadService(this.nodeID, name)
        .then((res) => {
          this.viewForm = {
            interfaces: {},
            about: {},
          }
          const { Interfaces, About } = res.data
          Object.keys(Interfaces).forEach((key) => {
            this.viewForm.interfaces[key] = Object.keys(Interfaces[key]).map((item) => ({
              key: item,
              value: Interfaces[key][item],
            }))
          })
          this.viewForm.about = About
          this.viewLoading = false
        })
        .catch(() => {
          this.viewLoading = false
        })
    },
    editService({ name }) {
      this.showCreateModal('edit')
      this.record = {
        name,
        file: '',
      }
    },
    remove({ name }) {
      deleteService(this.nodeID, name)
        .then(() => {
          this.$Message.success(this.$t('common.deleteSuccess'))
          this.loadData()
        })
        .catch(() => {})
    },
    showCreateModal(type) {
      this.oper = type
      this.createModalVisible = true
    },

    showUploadFileModal() {
      this.uploadFileModalVisible = true
    },
    getFileList() {
      this.$refs.fileListSelectRef.getFileList()
    },

    save() {
      this.$refs.Record.validate((valid) => {
        if (!valid) {
          return
        }
        this.btnLoading = true
        const data = { ...this.record }
        if (this.oper === 'create') {
          registerService(this.nodeID, data)
            .then((res) => {
              if (res.status === 201 && res.statusText === 'Created') {
                this.$Message.success(res.data)
              } else {
                this.$Message.success(this.$t('common.addSuccess'))
              }
              this.loadData()
              this.btnLoading = false
              this.createModalVisible = false
            })
            .catch(() => {
              this.btnLoading = false
            })
        } else if (this.oper === 'edit') {
          updateService(this.nodeID, data.name, data)
            .then((res) => {
              if (res.status === 200) {
                this.$Message.success(res.data)
              }
              this.loadData()
              this.btnLoading = false
              this.createModalVisible = false
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-file--link {
  float: right;
}
</style>
